import { render, staticRenderFns } from "./ExportComments.vue?vue&type=template&id=cdc3f00c&"
import script from "./ExportComments.vue?vue&type=script&lang=js&"
export * from "./ExportComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports